import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import "./InThePressRecentNews.css";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

const InThePressRecentNews = () => {
    const data = useStaticQuery(graphql`
        query InPressRecentNewsQuery {
            mobileImage: file(
                relativePath: { eq: "itp-recent-news-mob-1x-update.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(
                relativePath: { eq: "itp-recent-news-web-1x-update.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <WidgetContainer>
            <div className="recent-news">
                <h1>Recent News</h1>
                <div className="recent_news__main-card-news">
                    <p className="recent_news__main-card-news__date">
                        20 November
                    </p>
                    <div className="recent_news__main-card-news__img">
                        <Img
                            fluid={sources}
                            alt="PhonePe In The Press - Recent News"
                            imgStyle={{
                                width: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </div>
                    <div className="recent_news__main-card-news__card">
                        <a
                            href="https://www.livemint.com/companies/news/phonepe-crosses-350-mn-users-milestone-1-in-4-indians-now-use-platform-11641558522088.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 January</p>
                            <h2 className="recent_news__main-card-news__card__title">
                                PhonePe crosses 350 mn users milestone; 1 in 4
                                Indians now use the app
                            </h2>
                            <p className="recent_news__main-card-news__card__subtext ">
                                Fintech major PhonePe on Friday said it has
                                logged an annualised total payment value (TPV)
                                ...
                            </p>
                            <p className="recent_news__main-card-news__card__newsag">
                                Livemint
                            </p>
                        </a>
                    </div>
                </div>
                <div className="recent_news__card-container">
                    <div
                        className="recent_news__card-container__card"
                        id="card-one"
                    >
                        <a
                            href="https://economictimes.indiatimes.com/tech/startups/phonepe-conducts-rs-135-crore-esop-buyback/articleshow/87796676.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>20 November</p>
                            <h2 className="recent_news__card-container__card__title">
                                PhonePe conducts Rs 135-crore ESOP buyback
                            </h2>
                            <p className="recent_news__card-container__card__subtext">
                                PhonePe, part of the Walmart Inc-controlled
                                Flipkart Group, has conducted ESOP buyback worth
                                Rs 135 crore, but the company's founders—Sameer
                                Nigam and Rahul Chari...
                            </p>
                            <div className="recent_news__card-container__card__el-wrapper">
                                <div className="recent_news__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Economic Times</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="recent_news__card-container__card">
                        <a
                            href="https://timesofindia.indiatimes.com/city/bengaluru/processed-2bn-transactions-in-oct-phonepe/articleshow/87768664.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>18 November</p>
                            <h2 className="recent_news__card-container__card__title">
                                Processed 2 billion transactions in October:
                                PhonePe
                            </h2>
                            <p className="recent_news__card-container__card__subtext">
                                Digital payments platform PhonePe processed over
                                2 billion transactions in October. PhonePe had
                                crossed the 1-billion mark in...
                            </p>
                            <div className="recent_news__card-container__card__el-wrapper">
                                <div className="recent_news__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Times of India</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div
                        className="recent_news__card-container__card"
                        id="card-three"
                    >
                        <a
                            href="https://www.moneycontrol.com/news/business/startup/phonepe-introduces-tokenisation-solution-ahead-of-rbis-december-31-deadline-7667691.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 November</p>
                            <h2 className="recent_news__card-container__card__title">
                                PhonePe introduces tokenisation solution ahead
                                of RBI's December 31 deadline
                            </h2>
                            <p className="recent_news__card-container__card__subtext">
                                Digital payments and financial services company
                                PhonePe said on November 2 that it has launched
                                a tokenisation solution for online...
                            </p>
                            <div className="recent_news__card-container__card__el-wrapper">
                                <div className="recent_news__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Moneycontrol</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default InThePressRecentNews;
